import { load } from '@shopify/theme-sections'
import '../sections/section-metaobject-landing'
import '../sections/index-hero-slider'
import '../sections/section-enquire-form-v2'

load([
    `section-metaobject-landing`,
    `index-hero-slider`,
    `section-enquire-form-v2`
])
